module.exports = __webpack_public_path__ + "static/media/logo-pipi-dark.cb05aff2.png";